module.exports = __webpack_public_path__ + "img/paradin.11898dbf.png";